export class IndicadorProducao {
    codigo: string;
    descricao: string;

    constructor(codigo?: string, descricao?: string){
        this.codigo = codigo;
        this.descricao = descricao;
    }

    listar(): IndicadorProducao[] {
        return [
            new IndicadorProducao("S", "Produzido em escala relevante"),
            new IndicadorProducao("N", "Produzido em escala não relevante")
        ];
    }
}